export default __webpack_public_path__ + "865f928cbabcc9f8f2b50fb47a20bc63.woff";